import React, { useCallback, useContext, useMemo } from 'react';
import { type ReorderableItem, ReorderableList, UserContext } from 'venn-components';
import BlockItem from './components/BlockItem';
import { PanelHeader } from './components/PanelHeader';
import { useRecoilState } from 'recoil';
import { allBlockIdsState } from 'venn-state';

const OutlinePanel = () => {
  const { hasPermission } = useContext(UserContext);
  const [blockIds, setBlockIds] = useRecoilState(allBlockIdsState);

  const views = useMemo(
    () =>
      blockIds.map((id) => ({
        key: id,
      })) ?? [],
    [blockIds],
  );

  const onReorderBlocks = useCallback(
    (newItems: typeof views) => {
      const reordered = newItems.map(({ key }) => key);
      setBlockIds(reordered);
    },
    [setBlockIds],
  );

  const itemRenderer = useCallback(({ key }: ReorderableItem) => <BlockItem key={key} id={key} />, []);

  return (
    <>
      <PanelHeader.Root>
        <PanelHeader.Text>Blocks</PanelHeader.Text>
      </PanelHeader.Root>
      <div className="my-2.5 ml-[30px] mr-[15px] [&_ul>div]:flex [&_ul>div]:items-center [&_ul>div>i]:top-[unset] [&_ul>div>i]:left-[1px] max-w-full">
        <ReorderableList
          hideDelete
          reorderableItems={views}
          onReorderItems={onReorderBlocks}
          itemRenderer={itemRenderer}
          disabled={!hasPermission('STUDIO_REORDER_BLOCKS')}
          id="blockList"
        />
      </div>
    </>
  );
};

export default OutlinePanel;
